import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import * as React from 'react'
import { connect } from 'react-redux'
import { Button, Col, Row } from 'reactstrap'
import * as Redux from 'redux'
import * as Schedules from '../'
import { Loading } from '../../../components/loading'
import * as Sortable from '../../../components/sortable'
import * as Request from '../../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Render from './render'
import * as Types from './types'

interface HeaderProps {
  holidays: Types.HolidaysState,
  onAdd: Actions.DefaultAction,
  onReset: Actions.DefaultAction,
  onSubmit: Actions.DefaultAction,
}
const HeaderComponent = ({holidays, onAdd, onReset, onSubmit}: HeaderProps) =>
<div>
  <Row className="margin-auto">
    <Col sm="12" className="text-left page-header--padding">
      <Row className="page-header holiday">
        <Col md="12" lg="4">
          <span className="title">Holidays</span>
        </Col>
        <Col md="12" lg="8">
          <Button
            className="secondary-button"
            onClick={onAdd}
            disabled={holidays.state.isSaving}
            title="Add Holiday">
            Add
          </Button>
          <Button
            className="secondary-button rasa-save-btn"
            onClick={onSubmit}
            disabled={!holidays.state.isEditing || holidays.state.isSaving}
            title="Save Changes">
            Save
          </Button>
          <Button
            className="rasa-btn rasa-cancel-btn"
            onClick={onReset}
            disabled={!holidays.state.isEditing || holidays.state.isSaving}
            title="Reset">
            Reset
          </Button>
        </Col>
      </Row>
    </Col>
  </Row>
</div>

export const HeaderConnected = connect(
  ({schedules}: Schedules.WrappedState) => ({holidays: schedules.holidays}),
  {
    onAdd: Actions.addHoliday,
    onReset: Actions.resetHolidays,
    onSubmit: Actions.saveHolidays,
  },
)(HeaderComponent)

interface GridProps {
  dispatch: Redux.Dispatch<Redux.Action>
  holidays: Types.HolidaysState,
}
const SchedulesGridComponent = ({holidays, dispatch}: GridProps) => <div>
{ holidays.view.isLoading ?
    <span></span>
  : holidays.state.isSaving ?
     <Loading/>
  :
    <Row>
      <Col>
        <Grid data={Request.withDispatch(holidays.state.data.filter((h: Types.Holiday) => h.is_active), dispatch)}
              sortable={{
                allowUnsort: true,
                mode: 'multiple',
              }}
              sort={holidays.view.sort}
              onSortChange={(e: GridSortChangeEvent) => dispatch({
                                    options: { value: e.sort },
                                    type: Sortable.sortTableConstant(Constants.SORT_HOLIDAYS),
              })}>
            <GridColumn cell={Render.DateChooserCell} field="holiday" title="Holiday"/>
            <GridColumn cell={Render.HolidayTextCell} field="name" title="Name" editable={true}/>
            <GridColumn cell={Render.DeleteCell} width={75}/>
        </Grid>
      </Col>
    </Row>}
</div>

export const GridConnected = connect(
  ({schedules}: Schedules.WrappedState) => ({holidays: schedules.holidays}),
  (dispatch) => ({dispatch}),
)(SchedulesGridComponent)



// WEBPACK FOOTER //
// ./src/pages/schedules/holidays/component.tsx